/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Crisp_Tiger_ClapInputs */

const en_keen_crisp_tiger_clap = /** @type {(inputs: Keen_Crisp_Tiger_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm deletion`)
};

const de_keen_crisp_tiger_clap = /** @type {(inputs: Keen_Crisp_Tiger_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm deletion" |
*
* @param {Keen_Crisp_Tiger_ClapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_crisp_tiger_clap = /** @type {((inputs?: Keen_Crisp_Tiger_ClapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Crisp_Tiger_ClapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_crisp_tiger_clap(inputs)
	return de_keen_crisp_tiger_clap(inputs)
});